import type { WatchQueryFetchPolicy } from "@apollo/client";
import {
  GetSequoiaListItemsQueryVariables,
  useGetSequoiaListItemsQuery as useGetSequoiaListItemsBaseQuery,
} from "@covertree/agent-portal-graphql";

/**
 * Getting Sequoia list items based on the user's permissions. Executes the proper query and maps the query's result.
 *
 * @returns - sequoia policies list, total count, error and loading state.
 */
export function useGetSequoiaListItemsQuery(
  variables: GetSequoiaListItemsQueryVariables
) {
  const queryOptions: {
    fetchPolicy: WatchQueryFetchPolicy;
    variables: GetSequoiaListItemsQueryVariables;
  } = { fetchPolicy: "cache-and-network", variables };

  const { data, error, loading, previousData } =
    useGetSequoiaListItemsBaseQuery(queryOptions);

  return {
    error,
    loading: loading && !data,
    quotes: data?.getQuoteListItems.items ?? [],
    totalCount:
      data?.getQuoteListItems.pagination.total ??
      previousData?.getQuoteListItems.pagination.total ??
      0,
  };
}
